// Stations: the named camera poses of a room. A station is somewhere worth
// standing — a part of the system (the edge, the chassis, the control
// plane), a plot in the fleet city, or a section of a web page. Fly-to,
// the number keys, the scroll path and the DOM overlays all read the same
// list, so adding a place to stand is one entry.
//
//   { id, label, key?, pose: { position: [x,y,z], target: [x,y,z] } }
//
// `key` is the keyboard shortcut ('1'..'9'); when omitted the index + 1 is
// used for the first nine stations.

// A pose that looks at `center` from `dir` (unit-ish vector) at `dist`.
export function poseAt(center, dir = [0, 0.5, 1], dist = 8) {
  const len = Math.hypot(dir[0], dir[1], dir[2]) || 1;
  return {
    position: [center[0] + (dir[0] / len) * dist, center[1] + (dir[1] / len) * dist, center[2] + (dir[2] / len) * dist],
    target: [center[0], center[1], center[2]],
  };
}

export function station(id, label, pose, extra = {}) {
  return { id, label, pose, ...extra };
}

// Apply a world transform (translate + uniform scale) to a pose: used when
// a room is mounted inside another (an app room on its fleet plot).
export function transformPose(pose, { position = [0, 0, 0], scale = 1 } = {}) {
  const f = (p) => [p[0] * scale + position[0], p[1] * scale + position[1], p[2] * scale + position[2]];
  return { position: f(pose.position), target: f(pose.target) };
}

export const stationKey = (list, idx) => list[idx]?.key || (idx < 9 ? String(idx + 1) : null);
export const stationByKey = (list, key) => list.find((s, i) => stationKey(list, i) === key) || null;
